module.exports = __webpack_public_path__ + "img/ppmc-logo.97c71a1e.png";